export const REACT_APP_GOOGLE_CLIENT_ID =
  process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

export const REACT_APP_BACKEND_URI =
  process.env.REACT_APP_BACKEND_URI || "http://localhost:5000/api";
